import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "src/app/shared/services/auth.service";
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { DBPanelModule, DBSpinnerModule, DBIconModule } from '@db/db-core';

@Component({
    selector: 'app-callback',
    templateUrl: './callback.component.html',
    styleUrls: ['./callback.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        TranslateModule,
        DBPanelModule,
        DBSpinnerModule,
        DBIconModule
    ]
})
export class CallbackComponent implements OnInit {
    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private auth: AuthService
    ) {}

    ngOnInit(): void {
        const code = this.route.snapshot.queryParamMap.get('code');
        const state = this.route.snapshot.queryParamMap.get('state');
        if (code && state) {
            this.auth.handleAuthCallback$(code, state).subscribe({
                next: () => {
                    /**
                     * Tokens are now stored in the forgerock SDK. Also the SDK automatically stores them in localStorage.
                     * You can optionally retrieve user info:
                     * this.auth.getUserInfo$().subscribe(user => console.log('User info:', user));
                     *
                     * The authorization token will be retrieved from the forgerock.TokenManager by the
                     * TokenInterceptor that will automatically set it into the header of every api call
                     */
                    this.auth.updateAuthStateAfterLogin();
                    // Navigate to clear the query parameters
                    this.router.navigate(['/home'], { replaceUrl: true });
                },
                error: err => {
                    this.router.navigate(['/login']);
                }
            });
        } else {
            this.router.navigate(['/login']);
        }
    }
}
